var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLibya(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_617)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.98453 11.3044C0.713125 13.9338 0 16.8836 0 20.0001C0 23.1166 0.713125 26.0663 1.98453 28.6957L20 30.4348L38.0155 28.6957C39.2869 26.0663 40 23.1166 40 20.0001C40 16.8836 39.2869 13.9338 38.0155 11.3044L20 9.56531L1.98453 11.3044Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.98529 28.6957C5.22013 35.3856 12.0708 40.0001 20.0001 40.0001C27.9292 40.0001 34.78 35.3856 38.0148 28.6957H1.98529Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.98529 11.3044H38.0148C34.78 4.61445 27.9292 0 20.0001 0C12.0708 0 5.22013 4.61445 1.98529 11.3044Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6551 16.3427L26.296 18.604L28.9536 17.7423L27.31 20.0016L28.9508 22.2629L26.2942 21.3979L24.6506 23.6573L24.6523 20.8634L21.9956 19.9984L24.6533 19.1367L24.6551 16.3427Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1766 25.6522C17.055 25.6522 14.5244 23.1216 14.5244 20C14.5244 16.8785 17.055 14.3478 20.1766 14.3478C21.1499 14.3478 22.0657 14.5939 22.8653 15.0272C21.6109 13.8006 19.8956 13.0435 18.0027 13.0435C14.1607 13.0435 11.0462 16.158 11.0462 19.9999C11.0462 23.8419 14.1607 26.9564 18.0027 26.9564C19.8957 26.9564 21.611 26.1993 22.8653 24.9727C22.0657 25.4061 21.15 25.6522 20.1766 25.6522Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_617"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLibya);
export default __webpack_public_path__ + "static/media/libya.7b424b448e7717ebba95a15e1e024954.svg";
export { ForwardRef as ReactComponent };